import { injectable } from "@launchtray/tsyringe-async";
import { TriangleView } from "../triangles/TriangleView";
import { SquareView } from "./SquareView";

@injectable()
export class SquareViewFactory {
    public constructor() { }

    public createSquareView(triangleViews: Array<TriangleView>): SquareView {
        return new SquareView(triangleViews);
    }
}